import React, { useEffect, useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import api from "@/lib/api";

const Container = ({ children, className = "" }) => <div className={`max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;

export default function Team() {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/website/team").then(({ data }) => setTeam(data || [])); }, []);
  return (
    <div className="py-16 md:py-20">
      <Container>
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Notre équipe</span>
        <h1 className="mt-3 font-heading font-bold tracking-tight text-slate-900 text-4xl sm:text-5xl">Des professionnelles dédiées</h1>
        <p className="mt-5 text-lg text-slate-600 max-w-2xl">Une équipe engagée pour la réussite administrative de votre cabinet.</p>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {team.map((m) => (
            <div key={m.user_id} className="bg-white rounded-xl border border-slate-200 p-6 flex items-start gap-4">
              <Avatar className="h-20 w-20"><AvatarImage src={m.photo} /><AvatarFallback className="bg-primary/10 text-primary font-semibold text-lg">{(m.name || "?").split(" ").map((x) => x[0]).slice(0, 2).join("")}</AvatarFallback></Avatar>
              <div><h3 className="font-heading font-semibold text-lg text-slate-900">{m.name}</h3><p className="text-sm text-primary font-medium">{m.job_title}</p><p className="mt-2 text-sm text-slate-500 leading-relaxed">{m.bio}</p></div>
            </div>
          ))}
          {team.length === 0 && <p className="text-slate-500">L'équipe sera bientôt présentée ici.</p>}
        </div>
      </Container>
    </div>
  );
}
